import React, { Component } from 'react'
import './Pricing.scss'
import { connect } from 'react-redux'
import i18n from '@/i18n'
import { Trans } from 'react-i18next'

class Pricing extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }

    handleClickBuyButton = productId => {
        const { currentUser } = this.props
        if (!currentUser) {
            this.props.history.push('/login')
            return;
        }

        const { paymentMode } = this.props
        if (paymentMode) return alert("이미 이용중인 요금제가 있습니다.")

        this.props.history.push({
            pathname: '/payment/orderReview',
            state: { productId }
        })
    }


    renderProducts = () => {
        const circleElement = <div className="circle" />
        const xElement = (
            <div className="x-box">
                <div className="line1" />
                <div className="line2" />
            </div>
        )
        const cafe24Products = [
            {
                heading: i18n.t("web.pricing.new.general.title"),
                title: <Trans i18nKey='web.pricing.new.general.product.1month' />,
                subTitle: "개인/기업을 위한",
                price: 29800,
                billingUnit: i18n.t("Cafe24.payment.general.product.billingunit"),
                des: i18n.t("Cafe24.payment.general.product.des"),
                feat: [
                    {
                        label: i18n.t("common.pricing.new.feat.unlimitrendering"),
                        value: circleElement,
                    },
                    {
                        label: i18n.t("common.pricing.new.feat.vmcredit"),
                        value: i18n.t("common.pricing.new.feat.monthly.credit", { credit: 100 })
                    },
                    {  
                        label: i18n.t("common.header.workspace"),
                        value: "10GB"
                    },
                    {
                        label: i18n.t("web.pricing.feat.table.title.acc"),
                        value: i18n.t("web.pricing.feat.table.count", { count: 1 })
                    },
                    {
                        label: i18n.t("web.pricing.feat.table.title.resale"),
                        value: xElement
                    }

                ],
                color: 'blue',
                button: i18n.t("Cafe24.payment.general.product.button"),
                handleClick: () => this.handleClickBuyButton('63243e22c2cb943c903d28dc'),
                bottomDes: i18n.t("Cafe24.payment.general.product.bottomDes")
            }
            // {
            //     heading: i18n.t("Cafe24.payment.per.product.heading"),
            //     title: i18n.t("Cafe24.payment.per.product.title"),
            //     price: 44000,
            //     // billingUnit: i18n.t("Cafe24.payment.per.product.billingunit"),
            //     des: i18n.t("Cafe24.payment.per.product.des"),
            //     feat: {
            //         edit: <Trans i18nKey="Cafe24.payment.per.product.feat.edit"><span /></Trans>,
            //         copy: i18n.t("Cafe24.payment.per.product.feat.copy"),
            //         ratioAuto: i18n.t("Cafe24.payment.per.product.feat.ratio_auto"),
            //         gif: circleElement,
            //         thumb: circleElement
            //     },
            //     color: 'black',
            //     button: i18n.t("Cafe24.payment.per.product.button"),
            //     // handleClick: () => alert(i18n.t("Cafe24.payment.per.product.button.alert")),
            //     handleClick: () => this.handleClickBuyButton('63318d18c2cb943c9086d243'),
            //     bottomDes: i18n.t("Cafe24.payment.per.product.bottomDes")
            // }
        ]

        return (
            <div className="cafe24-product-area">
                {
                    cafe24Products.map(item => (
                        <div className='cafe24-product-wrapper'>
                            <div className='cafe24-product-heading'>{item.heading}</div>
                            <div className={`cafe24-product ${item.color}`}>
                                <div className='cafe24-product-content'>
                                    <div className='cafe24-product-title-wrap'>
                                        <div className='cafe24-product-title'>{item.title}</div>
                                        <div className='cafe24-product-sub-title'>{item.subTitle}</div>
                                    </div>
                                    <div className='cafe24-product-price'>
                                        <span className='currency'>₩</span>
                                        <span className='price'>{new Intl.NumberFormat('en-US').format(item.price)}</span>
                                        <span className='billing-unit'>{item.billingUnit}</span>
                                    </div>
                                    <div className='cafe24-product-des'>{item.des}</div>
                                    <div className='cafe24-product-btn' onClick={item.handleClick}>
                                        <div className='spacer' />
                                        <p className='text'>{item.button}</p>
                                        <img className='arrow-img' src="https://front.videomonster.com/images-7cuytg20/web/payment/btn_arrow.svg" alt="purchase-button-arrow" />
                                    </div>
                                    <div className='cafe24-feat-area'>
                                        {
                                            item.feat.map(({ label, value }) => (
                                                <div className='feat'>
                                                    <div className='feat-label'>{label}</div>
                                                    <div className='feat-value'>{value}</div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='cafe24-bottom-des'>{item.bottomDes}</div>
                        </div>
                    ))
                }
            </div>
        )
    }

    render() {
        return (
            <div className="cafe24-pricing-root-container">
                <div className="cafe24-main-section-container">
                    <div className="title">{i18n.t('web.pricing.new.main.title')}</div>
                    <div className="des">{i18n.t('web.pricing.new.main.desc')}</div>
                    <div className="des">{i18n.t('web.pricing.new.main.desc2')}</div>
                </div>
                {this.renderProducts()}
                <div className='feat-list-container'>
                    <div className='feat-list-title'>{i18n.t("common.payment.feat.title")}</div>
                    <div className='feat-list'>
                        <div className='feat-card'>
                            <img src='https://front.videomonster.com/images-7cuytg20/common/premium/watermark-remove-b.svg' alt=''/>
                            <span className='feat-label'>{i18n.t("common.payment.remove.watermark")}</span>
                        </div>
                        <div className='feat-card'>
                            <img src='https://front.videomonster.com/images-7cuytg20/common/premium/other-ratio-b.svg' alt=''/>
                            <span className='feat-label'>{i18n.t("common.payment.ratio.change")}</span>
                        </div>
                        <div className='feat-card'>
                            <img src='https://front.videomonster.com/images-7cuytg20/common/premium/gif-b.svg' alt=''/>
                            <span className='feat-label'>{i18n.t("common.payment.gif.export")}</span>
                        </div>
                        <div className='feat-card'>
                            <img src='https://front.videomonster.com/images-7cuytg20/common/premium/thumb-download-b.svg' alt=''/>
                            <span className='feat-label'>{i18n.t("common.payment.thumbnail.export")}</span>
                        </div>
                        <div className='feat-card'>
                            <img src='https://front.videomonster.com/images-7cuytg20/common/premium/quick-server-b.svg' alt=''/>
                            <span className='feat-label'>{i18n.t("common.payment.fast.server.render")}</span>
                        </div>
                    </div>
                </div>
                <div className='credit-uses-container'>
                    <div className='credit-uses-title'>{i18n.t("common.payment.credit.use.title")}</div>
                    <div className='credit-uses-list'>
                        <div className='credit-uses-desc-box'>
                            <div className='row-wrap title'>
                                <img src='https://front.videomonster.com/images-7cuytg20/common/premium/getty-images-b.svg' alt=''/>
                                <span>{i18n.t("web.pricing.new.feat.gettyimages")}</span>
                            </div>
                            <div className='row-wrap'>
                                <img className="credit-icon" src={"https://front.videomonster.com/images-7cuytg20/common/ai/credit.svg"} alt=''/>
                                <span>{i18n.t("common.payment.credit.use.label.img")} : {i18n.t("common.payment.credit.use.unit", { count: 5 })}</span>
                            </div>
                            <div className='row-wrap'>
                                <img className="credit-icon" src={"https://front.videomonster.com/images-7cuytg20/common/ai/credit.svg"} alt=''/>
                                <span>{i18n.t("common.payment.credit.use.label.video")} : {i18n.t("common.payment.credit.use.unit", { count: 10 })}</span>
                            </div>
                        </div>
                        <div className='credit-uses-desc-box'>
                            <div className='row-wrap title'>
                                <img src='https://front.videomonster.com/images-7cuytg20/common/premium/ai-images-b.svg' alt=''/>
                                <span>{i18n.t("common.header.ai")}</span>
                            </div>
                            <div className='row-wrap'>
                                <img className="credit-icon" src={"https://front.videomonster.com/images-7cuytg20/common/ai/credit.svg"} alt=''/>
                                <span>{i18n.t("common.payment.credit.use.count", { min: 5, max: 15 })}</span>
                            </div>
                            <div className='row-wrap small-desc'>
                                <span>{i18n.t("common.payment.credit.use.des")}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    currentUser: state.userStore.user,
    paymentMode: state.paymentModeStore.paymentMode,
})

export default connect(
    mapStateToProps,
    null
)(Pricing)